import React,{useState} from "react";
import "./Checkout.scss";
import brand from "../../../assets/images/brand.svg";
import info from "../../../assets/images/info.svg";
import Layout from "../../../layout";
 import CheckoutSuccess from './components/SucessPopup/checkoutSuccessPop'
function Checkout() {
  const [modalShow, setModalShow] = useState(false);

  return (
    <Layout>
      <div className="Checkout">
        <div className="container">
          <div className="form_container">
            <div className="header">Checkout</div>
            <div className="secondary_header">Delivery Address Information</div>
            <div className="form">
              <div className="label">Full name</div>
              <div className="input_container w_100">
                <input type="text" className="input" placeholder="Full name" />
              </div>
              <div className="info_label">
                <img src={info} alt="icon" />
                This name appers on delivery
              </div>
              <div className="label">Delivery Address</div>
              <div className="input_container w_100">
                <input
                  type="text"
                  className="input"
                  placeholder="Delivery Address"
                />
              </div>
              <div className="flex_label">
                <div className="label">Town/City</div>
                <div className="label">Country</div>
              </div>
              <div className="secondary_input">
                <div className="input_container w_50">
                  <input type="text" className="input" placeholder="Town/City" />
                </div>
                <div className="input_container w_50">
                  <input type="text" className="input" placeholder="Country" />
                </div>
              </div>
              <div className="flex_label">
                <div className="label">Postcode</div>
                <div className="label">Phone Number</div>
              </div>
              <div className="secondary_input">
                <div className="input_container w_50">
                  <input
                    type="text"
                    className="input"
                    placeholder="Enter postcode"
                  />
                </div>
                <div className="input_container w_50">
                  <input
                    type="text"
                    className="input"
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
            </div>
            <div className="btn"  onClick={() => setModalShow(true)}>Continue</div>
          </div>
          <div className="order_summery">
            <div className="header">Order Summary</div>
            <div className="order_container">
              <div className="order_details">
                <div className="order_heading">Adrenocorticotropic Hormone</div>
                <div className="qty">Qty:1</div>
                <div className="service">
                  Service Partner:
                  <img src={brand} alt="icon" />
                </div>
              </div>
              <div className="order_price">
                <div className="current_price">₦3600</div>
                <div className="price">₦4000</div>
              </div>
            </div>
            <div className="order_container">
              <div className="order_details">
                <div className="order_heading">Adrenocorticotropic Hormone</div>
                <div className="qty">Qty:1</div>
                <div className="service">
                  Service Partner:
                  <img src={brand} alt="icon" />
                </div>
              </div>
              <div className="order_price">
                <div className="current_price">₦3600</div>
                <div className="price">₦4000</div>
              </div>
            </div>
            <div className="order_container">
              <div className="order_details">
                <div className="order_heading">Adrenocorticotropic Hormone</div>
                <div className="qty">Qty:1</div>
                <div className="service">
                  Service Partner:
                  <img src={brand} alt="icon" />
                </div>
              </div>
              <div className="order_price">
                <div className="current_price">₦3600</div>
                <div className="price">₦4000</div>
              </div>
            </div>
            <div className="subtotal">
              <span>Subtotal</span>
              ₦96000
            </div>
            <div className="total">
              <span>Total</span>
              ₦96000
            </div>
          </div>
        </div>
      </div>
      <CheckoutSuccess
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
    </Layout>
  );
}

export default Checkout;
